<template>
	<v-card :key="page_key" class="ma-2 elevation-0" color="grey lighten-4">
		<v-card-title class="secondary--text"><v-icon large @click="goBack"> keyboard_arrow_left </v-icon> Practice Profile </v-card-title>
		<v-row>
			<v-card-text>
				<v-row v-for="(value, key) in practice" :key="'practice[' + key + '][' + page_key + ']'" class="pa-2 justify-center text-center">
					<v-card v-if="key != 'managers'" width="90%">
						<v-row>
							<v-col>
								<v-card-text class="font-weight-bold">{{ key }}</v-card-text>
							</v-col>
							<v-col>
								<v-card-text class="font-weight-bold">{{ value }}</v-card-text>
							</v-col>
						</v-row>
					</v-card>
				</v-row>
				<v-row :key="'practice.managers.' + page_key" class="pa-2 justify-center text-center">
					<v-card width="90%" class="pa-2 justify-center text-center">
						<v-card-title class="pa-2 justify-center text-center">Managers</v-card-title>
						<v-row class="pa-2 justify-center text-center">
							<v-card
								v-for="(manager, manager_key) in practice.managers"
								:key="'practice.managers.' + page_key + '.manager[' + manager_key + ']'"
								class="pb-2 ma-2 justify-center text-center card-rounded"
								:elevation="3"
							>
								<v-toolbar color="secondary" dense class="pt-0 pb-0 font-weight-bold white--text justify-center text-center"
									><v-spacer></v-spacer><v-toolbar-title class="justify-center text-center">{{ manager.name }} {{ manager.surname }}</v-toolbar-title
									><v-spacer></v-spacer
								></v-toolbar>

								<v-row class="pt-3 pl-3">
									<v-spacer></v-spacer>
									<v-card max-height="30" color="primary" class="font-weight-bold white--text pl-2 pr-2 card-rounded-bottom">Super Admin</v-card>
									<v-card max-height="30" color="primary" class="font-weight-bold white--text pl-2 pr-2 card-rounded-bottom">Manager</v-card>
									<v-spacer></v-spacer>
									<v-card max-height="30" color="primary" class="font-weight-bold white--text pl-2 pr-2 card-rounded-bottom">Example</v-card>
									<v-spacer></v-spacer>
								</v-row>

								<v-row class="justify-center text-center">
									<v-col>
										<v-btn text class="font-weight-bold pt-3 pb-1" @click="copyTextToClipboard(manager.email)">{{ manager.email }}</v-btn>
									</v-col>
								</v-row>
								<v-row class="justify-center text-center">
									<v-col>
										<v-btn text class="font-weight-bold pt-3 pb-1" @click="copyTextToClipboard(manager.contact)">{{ manager.contact }}</v-btn>
									</v-col>
								</v-row>
								<v-row class="justify-center text-center">
									<v-col><v-btn class="white--text" color="primary" :disabled="true" rounded>Impersonate</v-btn></v-col>
								</v-row>
							</v-card>
						</v-row>
					</v-card>
				</v-row>
			</v-card-text>
		</v-row>

		<v-row>
			<v-col>
				<v-expansion-panels accordion focusable>
					<component
						:is="component"
						v-for="(component, key) in fieldComponents"
						:key="component"
						:company="practice"
						:k="key"
						class="pa-2 justify-center text-center"
					></component>
				</v-expansion-panels>
			</v-col>
		</v-row>

		<v-card-actions class="justify-center text-center">
			<v-btn v-if="('approved' in practice && practice.approved == false) || !('approved' in practice)" class="white--text" color="primary" rounded @click="approvePractice"
				>Approve</v-btn
			>
			<v-btn v-else class="white--text" color="primary" rounded @click="unapprovePractice">Unapprove</v-btn>

			<v-dialog v-model="this.desireResetPracticePassword" width="500">
				<template #activator="{ on, attrs }">
					<v-btn :disabled="true" class="white--text" color="primary" rounded v-bind="attrs" v-on="on"> Reset Password </v-btn>
				</template>

				<v-card :loading="desireResetPracticePasswordLoading">
					<v-card-title class="headline grey lighten-2"> Confirm Reset practice Password </v-card-title>
					<v-card-text>Are you sure you wish to reset the password for user {{ practice.name }}?</v-card-text>

					<v-divider></v-divider>

					<v-card-actions>
						<v-btn class="white--text" color="primary" rounded @click="desireResetPracticePassword = false"> NO </v-btn>
						<v-spacer></v-spacer>
						<v-btn class="white--text" color="primary" rounded @click="doResetPassword"> I AM SURE </v-btn>
					</v-card-actions>
				</v-card>
			</v-dialog>
		</v-card-actions>
	</v-card>
</template>

<script>
// import moment from "moment";
import { bus } from '@/main';
import axios from 'axios'; //be able to make requests.
import store from '@/store'; //expose the vuex store, jwt token and user.

import accountManagement from '@/components/ui/dashboard/admin/cards/ViewPracticeProfile/accountManagement';
import contact from '@/components/ui/dashboard/admin/cards/ViewPracticeProfile/contact';
import addressAccordion from '@/components/ui/dashboard/admin/cards/ViewPracticeProfile/address';
import documents from '@/components/ui/dashboard/admin/cards/ViewPracticeProfile/documents';
import banking from '@/components/ui/dashboard/admin/cards/ViewPracticeProfile/banking';
import businessOperations from '@/components/ui/dashboard/admin/cards/ViewPracticeProfile/businessOperations';
// import business from
// import contact from
// import address from
// import about from
// import manages from

export default {
	name: 'PracticeSearchTool',
	components: { accountManagement, contact, addressAccordion, documents, businessOperations, banking }, //
	data: () => ({
		page_key: 0,

		local_practice: {},
		practice: {},
		desireResetpracticePassword: false,
		desireResetPracticePasswordLoading: false,

		//components that contain grouped like-fields for the profile.
		//Each component self manages, should emit "admin:viewPracticeProfile@updated" whenever the profile is modified. (NYI)
		fieldComponents: [
			'accountManagement',
			'banking',
			'businessOperations',
			'contact',
			'addressAccordion',
			// "about",
			// "managers",
			'documents',
		],
	}),

	async mounted() {
		this.practice = store.getters.getAdminViewingPractice;
	},
	created() {},
	beforeDestroy() {},
	methods: {
		copyEmail(email) {
			return this.copyTextToClipboard(email);
		},
		copyTextToClipboard(text) {
			var textArea = document.createElement('textarea');

			//
			// *** This styling is an extra step which is likely not required. ***
			//
			// Why is it here? To ensure:
			// 1. the element is able to have focus and selection.
			// 2. if the element was to flash render it has minimal visual impact.
			// 3. less flakyness with selection and copying which **might** occur if
			//    the textarea element is not visible.
			//
			// The likelihood is the element won't even render, not even a
			// flash, so some of these are just precautions. However in
			// Internet Explorer the element is visible whilst the popup
			// box asking the user for permission for the web page to
			// copy to the clipboard.
			//

			// Place in the top-left corner of screen regardless of scroll position.
			textArea.style.position = 'fixed';
			textArea.style.top = 0;
			textArea.style.left = 0;

			// Ensure it has a small width and height. Setting to 1px / 1em
			// doesn't work as this gives a negative w/h on some browsers.
			textArea.style.width = '2em';
			textArea.style.height = '2em';

			// We don't need padding, reducing the size if it does flash render.
			textArea.style.padding = 0;

			// Clean up any borders.
			textArea.style.border = 'none';
			textArea.style.outline = 'none';
			textArea.style.boxShadow = 'none';

			// Avoid flash of the white box if rendered for any reason.
			textArea.style.background = 'transparent';

			textArea.value = text;

			document.body.appendChild(textArea);
			textArea.focus();
			textArea.select();

			try {
				var successful = document.execCommand('copy');
				successful ? 'successful' : 'unsuccessful';
			} catch (err) {
				console.error('Unable to copy');
			}

			document.body.removeChild(textArea);
		},
		async updateAboutCompany() {},
		async doResetPassword() {
			this.desireResetPracticePasswordLoading = true;
			this.plus_page_key();
			this.$forceUpdate();
			const token = store.getters.jwtToken;
			axios
				.put(
					store.getters.getAPI + '/users/cognito/admin/users/' + this.practice.id + '/reset',
					{
						email: this.practice.email,
					},
					{ headers: { Authorization: token } }
				)
				.then(() => {
					this.desireResetPracticePassword = false;
					this.desireResetPracticePasswordLoading = false;
				})
				.finally(() => {
					this.plus_page_key();
					this.$forceUpdate();
				})
				.catch(() => {
					alert('something went wrong. Please contact a developer.');
				});
		},
		async unapprovePractice() {
			const token = store.getters.jwtToken;
			let response = await axios.put(
				store.getters.getAPI + '/companies/' + this.practice.id + '/manage',
				{
					approved: false,
				},
				{ headers: { Authorization: token } }
			);
			await store.dispatch('setPracticeViewingPractice', response.data.data); //refresh the users state. await it completed.
			this.practice = response.data.data;
			this.plus_page_key();
			this.$forceUpdate();
		},
		async approvePractice() {
			const token = store.getters.jwtToken;
			let response = await axios.put(
				store.getters.getAPI + '/companies/' + this.practice.id + '/manage',
				{
					approved: true,
				},
				{ headers: { Authorization: token } }
			);
			await store.dispatch('setPracticeViewingPractice', response.data.data); //refresh the users state. await it completed.
			this.practice = response.data.data;
			this.plus_page_key();
			this.$forceUpdate();
		},
		goBack() {
			bus.$emit('change-main-context', 'PracticeSearchTool');
		},

		plus_page_key() {
			this.page_key += 1;
		},
	},
};
</script>
